import React from 'react';
import { alertError, alertSuccess } from '../config/toast';
import Loader from '../components/loader';
import {
  faEdit,
  faPlus,
  faSpinner,
  faTrashAlt,
  faCamera,
} from '@fortawesome/free-solid-svg-icons';
import {
  getcategoryReq,
  /* getproductReq, rmproductReq, addproductReq, */ updproductReq,
  imgBase,
  getCategoryProdsReq,
  rmCategoryProdReq,
  addCategoryProdReq,
  updateCategoryProdReq,
  getUnitGroupReq
} from '../config/httpRoutes';
import {
  Row,
  Form,
  Col,
  Card,
  Button,
  Image,
  OverlayTrigger,
  Tooltip,
  ListGroup,
  Container
} from 'react-bootstrap';
import { defImg } from '../config/globals';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import AreaInput from '../components/areaInput';
import TextInput from '../components/textInput';
import Multiselect from 'multiselect-react-dropdown';

class CategoryProds extends React.Component {
  constructor(props) {
    super(props);
    this.multiselectRef = React.createRef();
    this.imgInputRef = React.createRef();
    this.player = React.createRef();

    this.state = {
      id: '',
      name: '',
      // quantity: '',
      image: '',
      img: null,
      desc: '',
      search: '',
      gvalue: '',
      selectedCat: [],
      products: null,
      errors: { name: '', image: '', desc: '' },

      categories: null,
      catid: '',
      unit_groups: null,
      selected_unit_group: [],// store selected object(s)
      unit_group_id: null,
      products: null,
      loading: false,
      deleteLoading: false,
      fetchLoading: true,
      form: false,
    };
  }

  componentDidMount() {
    this.getCategories();
    this.getUnitGruops()
  }

  getCategories = () => {
    this.setState({ fetchLoading: true });
    getcategoryReq()
      .then((res) => {
        this.setState({ categories: res.data, form: false });
      })
      .catch((err) => {
        alertError(err.response?.data?.msg || 'Could not fetch categories');
      })
      .finally(() => {
        this.setState({ fetchLoading: false });
      });
  };

  getUnitGruops = () => {
    this.setState({ fetchLoading: true });
    getUnitGroupReq()
      .then((res) => {
        this.setState({ unit_groups: res.data.data, });
      })
      .catch((err) => {
        alertError(err.response?.data?.msg || 'Could not fetch unit group');
      })
      .finally(() => {
        this.setState({ fetchLoading: false });
      });
  };


  getProducts = (category) => {
    // Fetch by category
    category = category || this.state.catid;
    this.setState({ fetchLoading: true });
    getCategoryProdsReq({ category })
      .then((res) => {
        this.setState({ products: res.data, form: false, catid: category });
      })
      .catch((err) => {
        alertError(err.response?.data?.msg || 'Could not fetch products');
      })
      .finally(() => {
        this.setState({ fetchLoading: false });
      });
  };

  searchProducts = (search) => {
    const category = this.state.catid;
    console.log(search)
    console.log(category)
    this.setState({ fetchLoading: true });
    getCategoryProdsReq({ category, search })
      .then((res) => {
        this.setState({ products: res.data, form: false, catid: category });
      })
      .catch((err) => {
        alertError(err.response?.data?.msg || 'Could not fetch products');
      })
      .finally(() => {
        this.setState({ fetchLoading: false });
      });
  };

  rmProduct = (id, index) => {
    this.setState({ deleteLoading: true });
    rmCategoryProdReq({ id })
      .then((res) => {
        const { products } = this.state;
        products.splice(index, 1);
        this.setState({ products });
      })
      .catch((err) => {
        alertError(err.response?.data?.msg || 'Could not remove product');
      })
      .finally(() => {
        this.setState({ deleteLoading: false });
      });
  };

  handleChange = ({ target: { name, value } }) => {
    this.setState({ [name]: value });
  };

  validate = () => {
    const { name, image, desc } = this.state;
    let errors = { name: '', image: '', desc: '' },
      isValid = true;

    if (!name) {
      errors.name = 'Enter name to continue';
      isValid = false;
    }
    if (!image) {
      errors.image = 'Upload image to continue';
      isValid = false;
    }
    if (!desc) {
      errors.desc = 'Enter description to continue';
      isValid = false;
    }

    this.setState({ errors });
    return isValid;
  };

  handleSubmit = (e) => {
    e.preventDefault();

    const addCatIds = this.multiselectRef.current
      .getSelectedItems()
      .map((item) => item.id)
      .join(',');

    let { id, name, image, unit_group_id, img, desc, /* quantity, */ catid, gvalue } =
      this.state;
    const images = []
    if (this.validate()) {
      if (img && img.length > 0) {
        for (const image of img) {
          images.push(new File([image], `${name}.${image.type.split('/')[1]}`))
        }
      }

      if (id) {
        this.setState({ loading: true });
        const formData = new FormData();
        formData.append('id', id);
        formData.append('name', name);
        // formData.append('quantity', quantity);
        formData.append('category', catid);
        for (const image of images) {
          formData.append('img', image);
        }
        formData.append('desc', desc);
        formData.append('addCatIds', addCatIds);
        formData.append('gvalue', gvalue);
        formData.append('unit_group_id', unit_group_id);
        updateCategoryProdReq(formData)
          .then((res) => {
            this.setState({ loading: false });
            alertSuccess('Product updated');
            this.getProducts();
          })
          .catch((err) => {
            this.setState({ loading: false });
            alertError(
              err?.response?.data?.msg ||
              err?.response?.data?.message ||
              'Could not complete request'
            );
          });
      } else {
        this.setState({ loading: true });
        const formData = new FormData();
        formData.append('name', name);
        // formData.append('quantity', quantity);
        formData.append('category', catid);
        // formData.append('img', images);
        for (const image of images) {
          formData.append('img', image);
        }
        formData.append('desc', desc);
        formData.append('addCatIds', addCatIds);
        formData.append('gvalue', gvalue);
        formData.append('unit_group_id', unit_group_id);

        addCategoryProdReq(formData)
          .then((res) => {
            this.setState({ loading: false });
            alertSuccess('Product added');
            this.getProducts();
          })
          .catch((err) => {
            this.setState({ loading: false });
            alertError(
              err?.response?.data?.msg ||
              err?.response?.data?.message ||
              'Could not complete request'
            );
          });
      }
    }
  };

  navigateAdd = () => {
    this.setState({
      id: '',
      name: '',
      /* quantity: '', */ image: '',
      desc: '',
      img: null,
      selectedCat: [],
      errors: { name: '', image: '', desc: '' },
      loading: false,
      form: true,
      gvalue: '',
    });
  };

  navigateEdit = (
    { id,
      name,
      image,
      description: desc /* , quantity */,
      categories,
      gvalue, unit_group_id }
  ) => {
    const selectedCat = [];
    for (const cat of this.state.categories) {
      if (categories?.find((i) => i === cat.id)) {
        selectedCat.push(cat);
      }
    }
    const selected_unit_group = [];
    if (unit_group_id)
      for (const unit_group of this.state.unit_groups) {
        if (unit_group.id === unit_group_id) {
          selected_unit_group.push(unit_group)
        }
      }

    this.setState({
      id,
      name,
      image,
      desc,
      selectedCat: selectedCat,
      selected_unit_group,
      img: null,
      errors: { name: '', image: '', desc: '' },
      loading: false,
      form: true,
      gvalue: gvalue,
    });
  };

  onChangeFile = (e) => {
    if (e.target.files.length > 0) {
      const files = []
      const base64Files = []

      for (const file of e.target.files) {
        files.push(file);

        let fileName = file.name;
        console.log("Added", fileName);

        // this.getBase64(file, (res) => {
        //   console.log("res", typeof res)
        //   base64Files.push(res)
        // });

        base64Files.push(URL.createObjectURL(file))
      }
      console.log("files", e.target.name, ": ", base64Files)
      this.setState({
        [e.target.name]: base64Files,
        img: files,
      });
    }
  };

  getBase64 = (file, cb) => {
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      cb(reader.result);
    };
    reader.onerror = function (error) {
      console.log('Error: ', error);
    };
  };

  initializeMedia = async () => {
    this.setState({ img: null, image: '' });

    if (!('mediaDevices' in navigator)) {
      navigator.mediaDevices = {};
    }

    if (!('getUserMedia' in navigator.mediaDevices)) {
      navigator.mediaDevices.getUserMedia = function (constraints) {
        var getUserMedia =
          navigator.webkitGetUserMedia || navigator.mozGetUserMedia;

        if (!getUserMedia) {
          return Promise.reject(new Error('getUserMedia Not Implemented'));
        }

        return new Promise((resolve, reject) => {
          getUserMedia.call(navigator, constraints, resolve, reject);
        });
      };
    }

    //Get the details of video inputs of the device
    const videoInputs = await this.getListOfVideoInputs();

    //The device has a camera
    if (videoInputs.length) {
      navigator.mediaDevices
        .getUserMedia({
          video: {
            deviceId: {
              exact: videoInputs[0].deviceId,
            },
          },
        })
        .then((stream) => {
          this.player.srcObject = stream;
        })
        .catch((error) => {
          console.error(error);
        });
    } else {
      alert('The device does not have a camera');
    }
  };

  capturePicture = async () => {
    var canvas = document.createElement('canvas');
    canvas.width = this.player.videoWidth;
    canvas.height = this.player.videoHeight;
    var contex = canvas.getContext('2d');
    contex.drawImage(this.player, 0, 0, canvas.width, canvas.height);
    this.player.srcObject.getVideoTracks().forEach((track) => {
      track.stop();
    });

    // console.log(canvas.toDataURL());
    const image = canvas.toDataURL();
    const img = await fetch(image).then((res) => res.blob());
    this.setState({ img, image });
  };


  InputForm = ({ id, name, image, img, desc, errors, loading, handleChange, handleSubmit, onChangeFile, imgInputRef, }) => {

    return <>
      <Row style={{ marginLeft: 0, marginRight: 0, width: '100%' }}>
        <Col
          md={{ span: 6, offset: 2 }}
          lg={{ span: 6, offset: 2 }}
          xs={12}
        >
          <Card style={{ marginTop: '10%' }}>
            <Card.Header>
              <Card.Title style={{ textAlign: 'center' }}>
                {id ? 'Update ' : 'Add '} Product
              </Card.Title>
            </Card.Header>
            <Card.Body>
              <Form onSubmit={handleSubmit}>
                <Form.Group style={{ position: 'relative' }}>
                  <Form.Control
                    name="image"
                    onChange={onChangeFile}
                    type="file"
                    multiple
                    style={{ display: 'none' }}
                    ref={imgInputRef}
                  />
                  {(image && image.length > 0) ? (
                    (img && img.length > 0) ? (
                      <Container>
                        <Row>
                          {image.map((imgSrc) => {
                            { console.log("imgSrc", imgSrc) }
                            return <Col xs={6} md={4}>
                              <Image
                                fluid
                                onClick={() => {
                                  imgInputRef.current.click();
                                }}
                                src={imgSrc}
                              />
                            </Col>
                          })}
                          <Col>
                            {/* <button
                                        type="button"
                                        className="btn-success btn btn-circle"
                                        style={{
                                          position: 'absolute',
                                          left: '25%',
                                          bottom: 0,
                                        }}
                                        onClick={() => {
                                          this.capturePicture();
                                        }}
                                      >
                                        <FontAwesomeIcon icon={faCamera} />
                                      </button> */}
                            <button
                              type="button"
                              className="btn-success btn btn-circle"
                              style={{
                                position: 'absolute',
                                right: '25%',
                                bottom: 0,
                              }}
                              onClick={() => {
                                imgInputRef.current.click();
                              }}
                            >
                              <FontAwesomeIcon icon={faPlus} />
                            </button>
                          </Col>
                        </Row>
                      </Container>
                    ) : (
                      <>
                        {/**TO Preview the Saved Image */}
                        <Image
                          fluid
                          style={{
                            marginLeft: '25%',
                            width: '50%',
                            height: 150,
                            cursor: 'pointer',
                          }}
                          onClick={() => {
                            imgInputRef.current.click();
                          }}
                          src={`${imgBase}${image}`}
                        />
                        <button
                          type="button"
                          className="btn-success btn btn-circle"
                          style={{
                            position: 'absolute',
                            left: '25%',
                            bottom: 0,
                          }}
                          onClick={() => {
                            this.capturePicture();
                          }}
                        >
                          <FontAwesomeIcon icon={faCamera} />
                        </button>
                        <button
                          type="button"
                          className="btn-success btn btn-circle"
                          style={{
                            position: 'absolute',
                            right: '25%',
                            bottom: 0,
                          }}
                          onClick={() => {
                            imgInputRef.current.click();
                          }}
                        >
                          <FontAwesomeIcon icon={faPlus} />
                        </button>
                      </>
                    )
                  ) : (
                    <>
                      {console.log("iamge", image)}
                      {/*** Default Image */}
                      <Image
                        fluid
                        style={{
                          marginLeft: '25%',
                          width: '50%',
                          height: 150,
                          cursor: 'pointer',
                        }}
                        src={defImg}
                      />
                      <button
                        type="button"
                        className="btn-success btn btn-circle"
                        style={{
                          position: 'absolute',
                          left: '25%',
                          bottom: 0,
                        }}
                        onClick={() => {
                          this.initializeMedia();
                        }}
                      >
                        <FontAwesomeIcon icon={faCamera} />
                      </button>
                      <button
                        type="button"
                        className="btn-success btn btn-circle"
                        style={{
                          position: 'absolute',
                          right: '25%',
                          bottom: 0,
                        }}
                        onClick={() => {
                          imgInputRef.current.click();
                        }}
                      >
                        <FontAwesomeIcon icon={faPlus} />
                      </button>
                    </>
                  )}
                </Form.Group>

                <Form.Group>
                  <TextInput
                    onChange={handleChange}
                    value={name}
                    error={errors.name}
                    name="name"
                    label="Name"
                  />
                </Form.Group>

                <Form.Group>
                  <AreaInput
                    onChange={handleChange}
                    value={desc}
                    error={errors.desc}
                    name="desc"
                    label="Description"
                  />
                </Form.Group>
                <Form.Group>
                  <Form.Label>Select Unit Group</Form.Label>
                  <Multiselect
                    singleSelect={true}
                    options={this.state.unit_groups}
                    onSelect={(selectedList, selectedItem) => {
                      this.setState({ ...this.state, unit_group_id: selectedList[0].id })
                    }}
                    selectedValues={this.state.selected_unit_group}
                    displayValue="name"
                    selectionLimit={1}
                  />
                </Form.Group>
                <Form.Group>
                  <Form.Label>Select Additional Category</Form.Label>
                  <Multiselect
                    options={this.state.categories} // Options to display in the dropdown
                    ref={this.multiselectRef}
                    selectedValues={this.state.selectedCat}
                    displayValue="name"
                  />
                </Form.Group>

                <select
                  class="form-select"
                  style={{ marginTop: 10 }}
                  name="gvalue"
                  onChange={handleChange}
                  value={this.state.gvalue}
                >
                  <option selected value="">
                    Seller G Value
                  </option>
                  <option value="g1">G1</option>
                  <option value="g2">G2</option>
                  <option value="g3">G3</option>
                  <option value="g4">G4</option>
                  <option value="g5">G5</option>
                  <option value="g6">G6</option>
                  <option value="g7">G7</option>
                  <option value="g8">G8</option>
                </select>

                <Button
                  variant="success"
                  type="submit"
                  style={{
                    marginLeft: '30%',
                    width: '40%',
                    marginTop: '25px',
                  }}
                  size="lg"
                  disabled={loading}
                >
                  {loading ? (
                    <FontAwesomeIcon icon={faSpinner} spin />
                  ) : (
                    'Save'
                  )}
                </Button>
              </Form>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </>
  }

  ProductListing = ({ products, fetchLoading, navigateAdd, navigateEdit, rmProduct, }) => {
    return < Row
      style={{
        margin: 0,
        padding: '2% 10%',
        width: '100%',
        alignItems: 'center',
      }}
    >
      {/**Product Listing */}
      {/* Adjusted Search Box */}
      <Col md={6} className="d-flex justify-content-start">
        <Form.Control
          type="text"
          placeholder="Search products..."
          onChange={(e) => this.searchProducts(e.target.value)}
          style={{
            maxWidth: '100%', // Takes full width in the column
            minWidth: '250px', // Minimum width for better responsiveness
            padding: '8px 10px'
          }}
        />
      </Col>

      {/* Adjusted Add Product Button */}
      <Col md={6} className="d-flex justify-content-end">
        <Button
          variant="success"
          onClick={navigateAdd}
          size="md"
          style={{ width: '150px', textAlign: 'center' }}
        >
          <FontAwesomeIcon icon={faPlus} /> Add Product
        </Button>
      </Col>

      {fetchLoading && <Loader />}

      {Array.isArray(products) && products.length > 0 ? (
        <div className="table-responsive">
          <table className="table table-hover table-attendance">
            <thead>
              <tr>
                <th>Image</th>
                <th>Name</th>
                <th>Description</th>
                <th className="th1">Action</th>
              </tr>
            </thead>
            <tbody>
              {products.map((product, i) => (
                <tr key={i}>
                  <td>
                    <Image
                      fluid
                      style={{ width: 50, height: 50 }}
                      src={`${imgBase}${product.image}`}
                    />
                  </td>
                  <td>{product.name}</td>
                  <td>{product.description}</td>
                  <td className="text-center">
                    <div className="course-control-box icons-container d-flex">
                      <OverlayTrigger overlay={<Tooltip>Edit</Tooltip>} delay={{ show: 150, hide: 150 }}>
                        <FontAwesomeIcon
                          icon={faEdit}
                          className="disabled-icon font-16 cursor-pointer mr-3"
                          onClick={() => navigateEdit(product)}
                        />
                      </OverlayTrigger>
                      <OverlayTrigger overlay={<Tooltip>Delete</Tooltip>} delay={{ show: 150, hide: 150 }}>
                        <FontAwesomeIcon
                          icon={faTrashAlt}
                          className="disabled-icon font-16 cursor-pointer"
                          onClick={() => rmProduct(product.id, i)}
                        />
                      </OverlayTrigger>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <p style={{ textAlign: 'center', marginTop: '20%' }}>No products found.</p>
      )}
    </Row>
  }

  render() {
    const {
      id,
      name,
      /* quantity, */ image,
      img,
      desc,
      products,
      deleteLoading,
      errors,
      loading,
      fetchLoading,
      form,
      categories,
      catid,
    } = this.state;
    const {
      handleChange,
      handleSubmit,
      navigateAdd,
      navigateEdit,
      rmProduct,
      onChangeFile,
      imgInputRef,
      getProducts,
    } = this;

    return (
      <>
        <Row
          style={{
            marginLeft: 0,
            marginRight: 0,
            paddingLeft: '10%',
            paddingRight: '10%',
            paddingTop: '5%',
          }}
        >
          <Col
            md={2}
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-between',
              marginTop: '0px',
              marginBottom: '15px',
              borderRight: '1px solid rgba(6,6,6,0.4)',
              borderBottom: '1.3px solid rgba(6,6,6,0.4)',
              // borderRadius: '4%',
              paddingRight: '30px'
            }}
          >
            <ListGroup as="ul" className='custom-list-item'>
              {Array.isArray(categories) && categories.length > 0 ? (
                categories.map(({ id, name }, i) => (
                  <ListGroup.Item
                    as={"li"}
                    active={catid === id}
                    key={`catgry${i}`}
                    onClick={() => {
                      getProducts(id);
                    }}
                  >
                    {name}
                  </ListGroup.Item>
                ))
              ) : (
                <></>
              )}
            </ListGroup>
          </Col>

          <Col
            md={10}
            style={{ display: 'flex', flexDirection: 'column', marginTop: '10px', marginBottom: '15px' }}
          >
            {catid ? (
              form ? (
                <this.InputForm id={id} name={name} desc={desc} image={image} img={img} imgInputRef={imgInputRef}
                  errors={errors}
                  handleChange={handleChange}
                  handleSubmit={handleSubmit} loading={loading} onChangeFile={onChangeFile} />
              ) : (
                <this.ProductListing fetchLoading={fetchLoading} navigateAdd={navigateAdd} navigateEdit={navigateEdit} products={products} rmProduct={rmProduct} />
              )
            ) : (
              <p
                style={{
                  position: 'fixed',
                  marginLeft: '34%',
                  marginTop: '20%',
                }}
              >
                No category selected.
              </p>
            )}
          </Col >
        </Row >
      </>
    );
  }

}

export default CategoryProds;
